export default (state) => state.router.location.pathname
